<footer class="d-flex flex-wrap justify-content-between align-items-center text-white bg-dark">
  <div class="mx-2 dropup btn-group">
    <a role="button" data-bs-toggle="dropdown" data-bs-display="static" aria-expanded="true"
       class="btn btn-sm btn-link dropdown-toggle">Language</a>
    <ul class="dropdown-menu" data-bs-popper="static">
      <li *ngFor="let language of languageService.getLanguages()">
        <a class="dropdown-item" (click)="switchLang(language)">
          {{ 'app.' + language.originalName | translate }}
        </a>
      </li>
    </ul>
  </div>

  <div class="col-md-4 justify-content-center">
    © {{ now() }} {{ 'app.all.rights.reserved' | translate }}
  </div>

  <ul class="nav col-md-4 justify-content-end">
    <li class="nav-item"><a href="#" class="nav-link px-2">Home</a></li>
    <li class="nav-item"><a href="#" class="nav-link px-2">Features</a></li>
    <li class="nav-item"><a href="#" class="nav-link px-2">Pricing</a></li>
    <li class="nav-item"><a href="#" class="nav-link px-2">FAQs</a></li>
    <li class="nav-item"><a href="#" class="nav-link px-2">About</a></li>
  </ul>
</footer>
